import {IUserProfile, IUserProfileBase} from "../bridge/define";
import {UserInstance} from "./user-instance";

export interface IAccountServiceClientJsOptions {
	/** default:true */
	useCookie?: boolean;
	/** 自动初始化 */
	init?: boolean;
	/** 开启调试 */
	debug?: boolean;
	/** https **/
	https?: boolean;
}

export interface ucExtendRequest<IProfile extends IUserProfileBase = IUserProfile> {
	user: UserInstance<IProfile>;
}
